import React from "react";
import styled from "styled-components";
import { TYPE_SIZE, COLORS, DEFAULT_TRANSITION_ALL } from "utils/styles";

const Wrapper = styled.div`
  margin-bottom: 2rem;

  transition: all 1s;
`;

const Icon = styled.i`
  ${DEFAULT_TRANSITION_ALL};
  display: block;
  font-size: 1.5rem !important;
  width: 2rem;
  transform: rotate(${(props) => (props.isOpen ? "180deg" : "0deg")});
  transform-origin: 10px 10px;
`;

const Question = styled.div`
  font-size: ${TYPE_SIZE.M};
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: solid ${COLORS.GRAY} 1px;
  cursor: pointer;
  line-height: 1.2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    opacity: 0.5;
  }
`;

const Answer = styled.div`
  height: ${(props) => (props.isOpen ? "fit-content" : 0)};
  overflow: hidden;
  transition: all 1s;
`;

const Faq = ({ question, answer }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleToggle = () => setIsOpen((state) => !state);

  return (
    <Wrapper>
      <Question className="mabry-medium" onClick={handleToggle}>
        {question}
        <Icon isOpen={isOpen} className="material-icons-round md-dark md-18">
          expand_more
        </Icon>
      </Question>
      <Answer isOpen={isOpen}>{answer}</Answer>
    </Wrapper>
  );
};

export default Faq;
